import { render, staticRenderFns } from "./jsbdownload.vue?vue&type=template&id=42a52feb"
import script from "./jsbdownload.vue?vue&type=script&lang=js"
export * from "./jsbdownload.vue?vue&type=script&lang=js"
import style0 from "./jsbdownload.vue?vue&type=style&index=0&id=42a52feb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports